import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import CareerPagesList from "./List";
import CareerPageEditor from "./Editor";

// /admin/career-pages — list view and editor entry points.
//   /admin/career-pages         → list
//   /admin/career-pages/new     → editor for a new page
//   /admin/career-pages/:id     → editor for an existing page
export default function CareerPages() {
  useEffect(() => { document.title = "Career pages - Ample Hire"; }, []);
  return (
    <Routes>
      <Route index element={<CareerPagesList />} />
      <Route path="new" element={<CareerPageEditor mode="new" />} />
      <Route path=":id" element={<CareerPageEditor mode="edit" />} />
    </Routes>
  );
}
